import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { loadingErrorSelector, loadingIsLoadingSelector } from '../../Redux/loading/selectors';
import { setLoading } from '../../Redux/loading/actions';
import { exportDataRequest } from './hooks';
import LoadingButton from '../Helpers/LoadingButton';
import { SaveErrorPropType } from '../../proptypes/errors';
import { Card, CardBody } from 'reactstrap';
import Box from '@material-ui/core/Box';


const FORM_KEY = 'mailing-export';
const EXPORT_TYPE = 'mailingaction';

const MailingExport = ({ handleSubmit, saveError, isLoading}) => {
    return (
        <Box mt={3}>
            <Card id="export-a1" data-cy="card-export-a1">
                <h6 className="card-header">Mailingaktionen (Hauptkontakte) Export</h6>
                <CardBody>
                    <p>Unter folgendem Link kann die Datei heruntergeladen werden.</p>
                    <form onSubmit={handleSubmit}>

                        <div className="text-center">
                            <LoadingButton
                                color="primary"
                                id={FORM_KEY}
                                title="Klicken um die Datei herunterzuladen"
                                type="submit"
                                isLoading={isLoading}
                            >
                                Herunterladen
                            </LoadingButton>
                        </div>
                    </form>
                </CardBody>
            </Card>
        </Box>
    )
};

MailingExport.propTypes = {
    saveError: SaveErrorPropType,
    handleSubmit: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
};

MailingExport.defaultProps = {
    saveError: null,
};

export default connect(
    (state) => ({
        saveError: loadingErrorSelector(state, FORM_KEY),
        isLoading: loadingIsLoadingSelector(state, FORM_KEY),
    }),
    (dispatch) => ({
        onSubmit: async (values) => {
            dispatch(setLoading(true, FORM_KEY));
            try {
                await exportDataRequest(EXPORT_TYPE, values);
            } finally {
                dispatch(setLoading(false, FORM_KEY));
            }
        },
    })
)(reduxForm({ form: FORM_KEY })(MailingExport));
